/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedIconBubbleEmail_viewer$ref = any;
export type PdpRespIconBubbles_viewer$ref = any;
export type PdpRespIconBubbles_viewer = {
    readonly isPinterestShareEnabled: boolean | null;
    readonly isFacebookShareEnabled: boolean | null;
    readonly " $fragmentRefs": PdpSharedIconBubbleEmail_viewer$ref;
    readonly " $refType": PdpRespIconBubbles_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespIconBubbles_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isPinterestShareEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "PINTEREST_SHARE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"PINTEREST_SHARE\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isFacebookShareEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "FACEBOOK_SHARE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FACEBOOK_SHARE\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedIconBubbleEmail_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c390af53d1b2b0a80836606a1b9520e0';
export default node;
